<template>
	<ButtonGeneric
		:id="id"
		class="button-primary"
		:disabled="disabled"
		@clicked="clicked">
		<slot />
	</ButtonGeneric>
</template>

<script setup>
	const { id } = defineProps({
		id: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	})

	const runtimeConfig = useRuntimeConfig()

	const emits = defineEmits(["clicked"])
	const clicked = () => {
		emits("clicked", { id: id })
	}
</script>

<style lang="scss" scoped>
	.button-primary {
		@apply text-btn-primary-text bg-btn-primary-bg hover:text-btn-primary-hoverText hover:bg-btn-primary-hoverBg;
	}
</style>
